import { render, staticRenderFns } from "./kiosk-details.vue?vue&type=template&id=022c05cf&scoped=true&"
import script from "./kiosk-details.vue?vue&type=script&lang=js&"
export * from "./kiosk-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c05cf",
  null
  
)

export default component.exports